import { secret } from './environment.secret';

export const environment = {
  production: true,
  api: 'https://api.digital.m-3.com/owner',
  oauth: {
    url: 'https://login.digital.gerances.ch/',
    realm: 'm3',
    clientId: 'm3-owners-portal-client',
  },
  ...secret,
  redirectUri: 'https://old.owner.digital.gerances.ch/',
};
